import {VisualizationService} from '../../api.service';
import { getField, updateField } from 'vuex-map-fields';
import _ from 'lodash';

let chartDataInitialState = {
	chartType: 'bar',
	chart_library: 'chartjs',
	selector: 'chart',
	title: 'Untitled Visualization',
	width: 900,
	height: 500,
	metric: -1,
	metricMixed: [
		{
			type: 'bar',
			field: -1,
			icon: 'chart-bar'
		}
	],
	metricStacked: [
		{
			type: 'bar',
			field: -1,
		}
	],
	dim: -1,
	field: -1,
	fieldsTable: [],
	fieldsDefinition: [],
	pivotMode: false,
	description: '',
	data: [],
	options: {
		responsive: true,
		maintainAspectRatio: false,
		title: {
			display: true,
			text: ''
		},
		scales: {
			xAxes: [],
			yAxes: []
		}
	},
	query_id: -1,
	status: 'private',
	stackedBar: false,
};

export default {
	namespaced: true,
	state: {
		items: [],
		pagination: {
			currentPage: 1,
			limit: 50,
			totalRows: 0
		},
		aggregation: {
			name: 'count',
			field: null
		},
		parameters: [],
		parametersChart: [],
		routeParameters: [],
		mergedParameters: [],
		bigNumber: {
			field: -1,
			description: '',
			value: '',
		},
		chartData: _.cloneDeep(chartDataInitialState),
		visualization_id: '',
		queriesId: [],
		reports: []
	},
	getters: {
		getVisualizations: state => state.items,
		getBigNumber: state => state.bigNumber,
		getField,
	},
	actions: {
		create: ({dispatch}, payload) => {
			return VisualizationService.create(payload)
				.then( res => {
					dispatch('setSuccess', res.data.message, { root: true });
					return res;
				})
				.catch( error => {
					dispatch('setExceptions', error.response.data, { root: true });
				})
		},
		update: ({dispatch}, payload) => {
			return VisualizationService.update(payload.id, payload)
				.then( res => {
					dispatch('setSuccess', res.data.message, { root: true });
					return res;
				})
				.catch( error => {
					dispatch('setExceptions', error.response.data, { root: true });
				})
		},
		delete: function ({dispatch}, payload) {
			return VisualizationService.destroy(payload.id)
				.then((res) => {
					dispatch('setSuccess', res.data.message, { root: true });
					dispatch('fetch');
				})
				.catch(error => {
					dispatch('setExceptions', error.response.data, { root: true });
				});
		},
		fetch: function ({commit, state, rootState}) {
			if (rootState.organizationSelected === '-1') {
				return false;
			}

			let params = {
				id: rootState.organizationSelected,
				limit: state.pagination.limit,
				page: state.pagination.currentPage,
				resource: 'organization',
				list: 'visualization'
			};
			return VisualizationService.getByCriteria(params)
				.then(res => {
					commit('SET_VISUALIZATIONS', res.data.data.visualizations.data);
					commit('SET_PAGINATION', res.data.data.visualizations);
				}).catch((error) => {
					return error;
				});
		},
		fetchVisualizationsByCriteria: function ({commit, rootState}, payload) {
			return VisualizationService.searchByCriteria(rootState.organizationSelected, payload)
				.then(res => {
					commit('SET_VISUALIZATIONS', res.data.data.visualizations)
				}).catch((error) => {
					return error;
				});
		},
		fetchVisualization: function ({commit}, visualization_id) {
			return VisualizationService.get(visualization_id)
				.then(res => {
					commit('SET_VISUALIZATION', res.data.data.visualization);
					return res;
				});
		},
		fetchVisualizationForReport: function ({commit}, payload) {
			let visualization_id = payload.visualization_id;
			let report_id = payload.report_id;
			return VisualizationService.get(visualization_id + '?report_id=' + report_id)
				.then(res => {
					commit('SET_VISUALIZATION', res.data.data.visualization);
					commit('SET_QUERIES_ID', {queryId: res.data.data.visualization.query_id, id: res.data.data.visualization.id});
					return res;
				});
		},
		fetchSharedVisualization: function ({commit, dispatch, state}, payload) {
			return dispatch('fetchVisualization', payload.visualization_id).then(() => {
				if (dispatch('routeHasParameters', payload.routeQuery)) {
					dispatch('getParametersAsArray', payload.routeQuery).then(() => {
						dispatch('mergeArrays', {
							a: state.parameters,
							b: state.routeParameters,
							key: 'name'
						}).then(() => {
							commit('SET_VISUALIZATION_PARAMETERS', state.mergedParameters);
							commit('SET_PARAMETERS');
						});
					});
				}
			});
		},
		getStatus: function ({commit}, visualization_id) {
			return VisualizationService.getStatus(visualization_id)
				.then(res => {
					return res;
				});
		},
		save: function ({commit, dispatch, state, rootState}, visualization_id = null) {
			let metric = '';
			if (state.chartData.chartType === 'mixed') {
				metric = JSON.stringify(state.chartData.metricMixed);
			}
			else if((state.chartData.chartType === 'bar' || state.chartData.chartType === 'vbar') && state.chartData.stackedBar) {
				let baseBar = {
					"type": "bar",
					"field": state.chartData.metric,
				};
				metric = JSON.parse(JSON.stringify(state.chartData.metricStacked));
				metric.unshift(baseBar);
				metric = JSON.stringify(metric);
			}
			else {
				metric = JSON.stringify(state.chartData.metric);
			}

			let data = '';
			if (state.chartData.chartType === 'table') {
				data = JSON.stringify({
					fields: state.chartData.fieldsTable,
					fieldsDefinition: state.chartData.fieldsDefinition,
					pivotMode: state.chartData.pivotMode
				});
			}
			else if (state.chartData.chartType === 'bigNumber') {
				data = JSON.stringify({
					field: state.chartData.field,
				});
			}
			else if ((state.chartData.chartType === 'bar' || state.chartData.chartType === 'vbar') && state.chartData.stackedBar) {
				data = "{\"xaxis\": \"" + state.chartData.dim + "\", \"yaxis\": " + metric + ", \"stacked\": true }";
			}
			else {
				data = "{\"xaxis\": \"" + state.chartData.dim + "\", \"yaxis\": " + metric + " }";
			}

			let payload = {
				"title": state.chartData.title,
				"organization_id": rootState.organizationSelected,
				"query_id": state.chartData.query_id,
				"type": state.chartData.chartType,
				"data": data,
				"chart_library": state.chartData.chart_library,
				"status": state.chartData.status,
				"description": state.chartData.description,
			};

			if (visualization_id) {
				return VisualizationService.update(visualization_id, payload)
					.then(res => {
						dispatch('setSuccess', res.data.message, {root: true});
					})
					.catch(error => {
						dispatch('setExceptions', error.response.data, {root: true})
					});
			}
			else {
				return VisualizationService.create(payload)
					.then((res) => {
						dispatch('setSuccess', res.data.message, {root: true});
						return res;
					})
					.catch(error => {
						dispatch('setExceptions', error.response.data, {root: true})
					});
			}
		},
		setInitialStatus: function({commit, dispatch}) {
			commit('SET_PAGINATION', { current_page: 1, total: 0 });
			dispatch('fetch');
		},
		getParametersAsArray: function ({commit}, parameters) {
			return new Promise(resolve => {
				for (let [key, value] of Object.entries(parameters)) {
					let parameter = {
						"name": key,
						"default": value
					};
					commit('SET_ROUTE_PARAMETERS', parameter);
					resolve();
				}
			})
		},
		mergeArrays: function ({commit}, payload) {
			payload.a.forEach(aitem => {
				let found = payload.b.find( bitem => aitem[payload.key] === bitem[payload.key]);
				if (found) {
					aitem.default = found.default
				}
				commit('SET_MERGED_PARAMETERS', aitem);
			});
		},
		routeHasParameters: function ({commit}, routeQuery) {
			return (typeof routeQuery !== "undefined" && Boolean(Object.keys(routeQuery)[0]));
		},
		getReports: ({commit}, payload) => {
			return VisualizationService.getReports(payload).then((res) => {
				commit('SET_VISUALIZATION_REPORTS', res.data.data.reports);
			}).catch((error) => {
				dispatch('setExceptions', error.response.data, {root: true});
			});
		}
	},
	mutations: {
		updateField,
		CLEAR_VISUALIZATION: (state, ) => {
			state.chartDate.chartType = 'bar';
		},
		SET_PAGINATION: (state, element) => {
			state.pagination.currentPage = element.current_page;
			state.pagination.totalRows = element.total;
		},
		SET_CURRENT_PAGE: (state, page) => {
			state.pagination.currentPage = page;
		},
		SET_VISUALIZATION_ID: (state, visualization_id) => {
			state.visualization_id = visualization_id;
		},
		SET_VISUALIZATION: (state, visualization) => {
			state.chartData.chartType = visualization.type;
			state.chartData.type = visualization.type;
			state.chartData.title = visualization.title;
			state.chartData.options.title.text = visualization.title;
			state.chartData.type = visualization.type;
			state.chartData.status = visualization.status;
			state.chartData.query_id = visualization.query_id;
			state.chartData.chart_library = "chartjs";
			state.parameters = visualization.parameters;
			let objdata = JSON.parse(visualization.data);
			state.chartData.description = visualization.description;
			state.chartData.field = objdata.field ? objdata.field : -1;
			state.chartData.fieldsTable = objdata.fields ? objdata.fields : [];
			state.chartData.fieldsDefinition = objdata.fieldsDefinition ? objdata.fieldsDefinition: []
			state.chartData.pivotMode = objdata.pivotMode ? objdata.pivotMode : false;
			state.chartData.dim = objdata.xaxis ? objdata.xaxis : -1;
			if (state.chartData.chartType === 'mixed') {
				state.chartData.metricMixed = objdata.yaxis;
			}
			else if ((state.chartData.chartType === 'bar' || state.chartData.chartType === 'vbar') && objdata.stacked) {
				state.chartData.metric = objdata.yaxis[0].field;
				state.chartData.metricStacked = objdata.yaxis;
				state.chartData.metricStacked.splice(0, 1);
				state.chartData.stackedBar = true;
			}
			else {
				state.chartData.metric = objdata.yaxis ? objdata.yaxis : -1;
			}
		},
		SET_VISUALIZATIONS: (state, visualizations) => {
			state.items = visualizations;
		},
		SET_CHARTDATA_INITIAL_STATE: (state) => {
			state.chartData = _.cloneDeep(chartDataInitialState);
		},
		SET_CHARTDATA_DATA: (state, data) => {
			state.chartData.data = data;
		},
		SET_DESCRIPTION: (state, description) => {
			state.visualization.description = description;
		},
		SET_PARAMETERS: (state) => {
			state.parametersChart = JSON.parse(JSON.stringify(state.parameters));
		},
		SET_ROUTE_PARAMETERS: (state, parameter) => {
			state.routeParameters.push(parameter);
		},
		SET_MERGED_PARAMETERS: (state, parameter) => {
			state.mergedParameters.push(parameter);
		},
		SET_VISUALIZATION_PARAMETERS: (state, params) => {
			state.parameters.splice(0, state.parameters.length);
			state.parameters = params;
		},
		SET_QUERIES_ID: (state, payload) => {
			state.queriesId.push(payload);
		},
		CLEAR_QUERIES_ID: (state) => {
			state.queriesId = [];
		},
		SET_VISUALIZATION_REPORTS: (state, reports) => {
			state.reports = reports;
		},
		SET_FIELDS_TABLE: (state, fields) => {
			state.chartData.fieldsTable = fields;
		},
		SET_FIELDS_DEFINITION: (state, definition) => {
			state.chartData.fieldsDefinition = definition;
		},
		SET_PIVOT_MODE: (state, mode) => {
			state.chartData.pivotMode = mode;
		},
		SET_PAGINATION_LIMIT: (state, limit) => {
			state.pagination.limit = limit;
		}
	},
}